import React, {useState, useEffect} from "react";

function App() {
    const [isActive, setIsActive] = useState('pictures');

    return (
        <div className="tabs">
            <ul>
                <li className={isActive == 'pictures' && 'is-active'}><a onClick = {() => setIsActive('pictures')}>Pictures</a></li>
                <li className={isActive == 'music' && 'is-active'}><a onClick = {() => setIsActive('music')}>Music</a></li>
                <li className={isActive == 'videos' && 'is-active'}><a onClick = {() => setIsActive('videos')}>Videos</a></li>
                <li className={isActive == 'documents' && 'is-active'}><a onClick = {() => setIsActive('documents')}>Documents</a></li>
                </ul>
        </div>
    );
  }
  
  export default App;